import { render, staticRenderFns } from "./PlaquenilCumulativeCalc.vue?vue&type=template&id=275ddf38&scoped=true&"
import script from "./PlaquenilCumulativeCalc.vue?vue&type=script&lang=js&"
export * from "./PlaquenilCumulativeCalc.vue?vue&type=script&lang=js&"
import style0 from "./PlaquenilCumulativeCalc.vue?vue&type=style&index=0&id=275ddf38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ddf38",
  null
  
)

export default component.exports